var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.action}},[_c('div',{staticClass:"icon btn"},[_c('div',{staticClass:"tooltip",class:_vm.dynamicStyle},[_vm._v(" "+_vm._s(_vm.tooltipText))]),_c('img',{attrs:{"src":_vm.imageSource}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }